(function () {
  const SHADOW_STYLE_ID = 'ssw-shopify-chat-icon-style';
  const DOC_STYLE_ID = 'ssw-shopify-chat-doc-style';
  const LEGACY_TOGGLE_ID = 'ssw-shopify-chat-toggle';
  const LEGACY_DOC_STYLE_ID = 'ssw-shopify-chat-toggle-style';

  let pollTimer = null;

  function getChatIconUrl() {
    return typeof window.sswChatIconUrl === 'string' ? window.sswChatIconUrl : '';
  }

  function getShadowStyleText(iconUrl) {
    const safeUrl = iconUrl.replace(/"/g, '\\"');

    return (
      '.chat-toggle {' +
      'background: transparent !important;' +
      'background-color: transparent !important;' +
      'border: none !important;' +
      'box-shadow: none !important;' +
      'padding: 0 !important;' +
      'min-width: 0 !important;' +
      'width: auto !important;' +
      'height: auto !important;' +
      'font-size: 0 !important;' +
      'line-height: 0 !important;' +
      'color: transparent !important;' +
      'gap: 0 !important;' +
      '}' +
      '.chat-toggle svg,' +
      '.chat-toggle span,' +
      '.chat-toggle [class*="text"] {' +
      'display: none !important;' +
      '}' +
      '.chat-toggle::before {' +
      'content: "";' +
      'display: block;' +
      'width: 60px;' +
      'height: 60px;' +
      'flex-shrink: 0;' +
      'background-image: url("' +
      safeUrl +
      '");' +
      'background-repeat: no-repeat;' +
      'background-position: center;' +
      'background-size: contain;' +
      '}'
    );
  }

  function getChatHosts() {
    return Array.from(document.querySelectorAll('inbox-online-store-chat, #ShopifyChat'));
  }

  function getActiveChatHost() {
    return (
      getChatHosts().find(function (host) {
        return host.shadowRoot && host.shadowRoot.querySelector('.chat-toggle');
      }) || null
    );
  }

  function removeLegacyCustomToggle() {
    const legacyToggle = document.getElementById(LEGACY_TOGGLE_ID);
    if (legacyToggle) legacyToggle.remove();

    const legacyStyle = document.getElementById(LEGACY_DOC_STYLE_ID);
    if (legacyStyle) legacyStyle.remove();
  }

  function injectDocumentStyles() {
    if (document.getElementById(DOC_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = DOC_STYLE_ID;
    style.textContent =
      'inbox-online-store-chat[data-ssw-chat-duplicate="true"] {' +
      'display: none !important;' +
      '}';

    document.head.appendChild(style);
  }

  function hideDuplicateHosts(active) {
    getChatHosts().forEach(function (host) {
      if (host === active) {
        if (host.hasAttribute('data-ssw-chat-duplicate')) {
          host.removeAttribute('data-ssw-chat-duplicate');
        }
        if (host.style.display === 'none') {
          host.style.removeProperty('display');
        }
        host.style.removeProperty('transform');
        return;
      }

      if (host.getAttribute('data-ssw-chat-duplicate') !== 'true') {
        host.setAttribute('data-ssw-chat-duplicate', 'true');
      }
      if (host.style.display !== 'none') {
        host.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function injectShadowStyles(shadowRoot) {
    const iconUrl = getChatIconUrl();
    if (!shadowRoot || !iconUrl) return false;

    let style = shadowRoot.getElementById(SHADOW_STYLE_ID);
    const styleText = getShadowStyleText(iconUrl);

    if (!style) {
      style = document.createElement('style');
      style.id = SHADOW_STYLE_ID;
      shadowRoot.appendChild(style);
    }

    if (style.textContent === styleText) return true;

    style.textContent = styleText;
    return true;
  }

  function cleanupLegacyIconNodes(shadowRoot) {
    shadowRoot.querySelectorAll('[data-ssw-chat-icon]').forEach(function (node) {
      node.remove();
    });
  }

  function enhanceChatIcon() {
    if (!getChatIconUrl()) return false;

    removeLegacyCustomToggle();
    injectDocumentStyles();

    const active = getActiveChatHost();
    hideDuplicateHosts(active);

    if (!active?.shadowRoot) return false;

    cleanupLegacyIconNodes(active.shadowRoot);
    return injectShadowStyles(active.shadowRoot);
  }

  function stopPolling() {
    if (pollTimer !== null) {
      window.clearInterval(pollTimer);
      pollTimer = null;
    }
  }

  function initIconCustomization() {
    if (enhanceChatIcon()) {
      return;
    }

    let attempts = 0;
    pollTimer = window.setInterval(function () {
      attempts += 1;
      if (enhanceChatIcon() || attempts >= 30) {
        stopPolling();
      }
    }, 500);
  }

  function clickInboxToggle(host) {
    if (!host?.shadowRoot) return false;

    const isOpen = host.getAttribute('is-open') === 'true';
    const selector = isOpen ? '.chat-app--close-button' : '.chat-toggle';
    const button = host.shadowRoot.querySelector(selector);

    if (!button) return false;

    button.click();
    return true;
  }

  function openShopifyInbox() {
    const host = getActiveChatHost();
    if (host && clickInboxToggle(host)) {
      return Promise.resolve(true);
    }

    return new Promise(function (resolve) {
      let attempts = 0;
      const timer = window.setInterval(function () {
        attempts += 1;
        const currentHost = getActiveChatHost();

        if (currentHost && clickInboxToggle(currentHost)) {
          window.clearInterval(timer);
          resolve(true);
          return;
        }

        if (attempts >= 40) {
          window.clearInterval(timer);
          resolve(false);
        }
      }, 250);
    });
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-ssw-open-chat]');
    if (!trigger) return;

    event.preventDefault();

    openShopifyInbox().then(function (opened) {
      if (opened) return;

      const url = new URL(window.location.href);
      url.searchParams.set('show_chat', '');
      window.location.assign(url.toString());
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIconCustomization);
  } else {
    initIconCustomization();
  }
})();
